<div class="PGDatetimePicker input-group">
        <app-pg-date-picker [fieldId]="fieldId" [readonly]="readonly" [required]="required"
        [ngModel]="getFieldValueDateTime('date')" (ngModelChange)="setFieldValueDateTime('date', $event);">
        </app-pg-date-picker>
        <div class="px-2"></div>
        <app-pg-time-picker [fieldId]="fieldId ? fieldId + '-time' : null" [readonly]="readonly" [required]="required"
        [ngModel]="getFieldValueDateTime('time')" (ngModelChange)="setFieldValueDateTime('time', $event);">
        </app-pg-time-picker>
        <button type="button" class="btn input-group-text" [disabled]="readonly"
                (click)="setFieldValue(null);"
                [attr.aria-label]="'pg-datetime-picker.a11y.clear' | locTranslate">
                <i class="fa-regular fa-times" aria-hidden="true"></i>
        </button>
</div>
